/**
 * Returns a display-friendly name for a user.
 *
 * Priority: displayName > email prefix > 'Unknown'
 * Optionally truncates with ellipsis.
 *
 * @param {string|null} displayName - The user's chosen display name
 * @param {string|null} email - The user's email address (fallback)
 * @param {Object} options - { truncate: number } to limit length
 * @returns {string}
 */
export function getDisplayName(displayName, email, options = {}) {
  const name = displayName || (email ? email.split('@')[0] : 'Unknown');
  if (options.truncate && name.length > options.truncate) {
    return name.slice(0, options.truncate) + '...';
  }
  return name;
}
